module.exports = __webpack_public_path__ + "img/platform-channel.56819e8f.svg";